import api from "../../config/client.axios.api";

export const getAccountOfStoreApiRequest = async (storeId: string) => {
  const response = await api.get(`/store/account-of-store/${storeId}`);
  return response.data;
};
